<template>
    <el-dialog
        :visible.sync="show"
        append-to-body
        width="500px"
        class="msg-dlg"
    >
        <template slot="title">
            <div class="dlg-title">
                支付失败提醒
            </div>
        </template>
        <div
            class="container"
        >
            <div class="message-container">
                <div class="message-title">
                    尊敬的用户：您有{{ failCount }}笔支付失败数据，请及时处理！
                </div>
                <div
                    v-for="(item, index) in salaryPayFailList"
                    :key="index"
                    class="message-row"
                >
                    失败原因：{{ item.errorMsg }}，错误信息：
                    <el-button
                        v-for="payFailJournal in item.payFailJournals"
                        :key="payFailJournal.payJournalId"
                        type="text"
                        @click="jump(payFailJournal)"
                    >
                        收款方{{ payFailJournal.payeeName }}（账户:{{ payFailJournal.payeeAccount }} 流水id:{{ payFailJournal.payJournalId }} ）
                    </el-button>。
                </div>
                <div>如有疑问请及时联系小象超市用工组。</div>
            </div>
        </div>
        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                type="primary"
                @click="cancel"
            >
                关闭
            </el-button>
        </div>
    </el-dialog>
</template>
<script>
import { flatten, cloneDeep } from '@mcfe/tools';
import moment from 'moment';

export default {
    name: 'SalaryPayFailDlg',
    components: {},
    data() {
        return {
            show: false,
            salaryPayFailList: [],
            roleType: 2,
        };
    },
    computed: {
        failCount() {
            const list = this.salaryPayFailList.map((payFailItem) => payFailItem.payFailJournals);
            return list.flat ? list.flat().length : flatten(list).length;
        },
    },
    async created() {
        const record = localStorage.getItem('renxiao_tip_record');
        const now = (new Date()).getTime();
        if (!record || now > record) {
            const nextRecord = new Date(`${moment().add(1, 'days').format('YYYY/MM/DD')} 00:00:00`);
            localStorage.setItem('renxiao_tip_record', nextRecord.getTime());
            const salaryPayFailList = await this.$hPost('/api/vss/shepherd/finance/salaryTService/salaryPayFailList', {});
            if (salaryPayFailList && salaryPayFailList.length > 0) {
                this.popup(salaryPayFailList);
            }
        }

        const { roleType } = await this.$hPost('/api/emp-vss/supplier/admin/login_account', {});
        this.roleType = roleType;
    },
    methods: {
        cancel() {
            this.show = false;
        },
        popup(salaryPayFailList) {
            this.salaryPayFailList = cloneDeep(salaryPayFailList);
            this.show = true;
        },
        jump({ payeeName, paymentObject }) {
            if (paymentObject === 1) {
                if (this.roleType === 1) {
                    this.$tools.linkTo('/renxiao/payMethod/management.html');
                } else {
                    this.$message.warning('请联系主接口人登陆供应商服务系统，对发薪账户信息进行维护！');
                }
            } else {
                this.$tools.linkTo('/renxiao/memberBankAccount.html', { keyword: payeeName });
            }
        },
    },
};
</script>
<style scoped lang="scss">
.msg-dlg {
    display: flex;
    justify-content: center;
    align-items: center;
    /deep/ .el-dialog {
        margin: auto !important;
    }
    /deep/ .el-dialog__header {
        background-color: #ffffff;
        height: auto;
        .dlg-title {
            display: flex;
            font-size: 18px;
            color: #292929;
            letter-spacing: 0;
            line-height: 18px;
            font-weight: 500;
            padding: 24px;
        }
        .el-icon-close {
            font-size: 15px;
            color: #000000;
        }
    }
    /deep/ .el-dialog__body {
        padding: 0 12px;
    }
    /deep/ .el-dialog__footer {
        background-color: #ffffff;
    }
    .container {
        margin: 20px 15px;
        .message-container {
            .message-title {
                color: red;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .message-row {
                padding: 5px 0;
                line-height: 20px;
                .message-no {
                    width: 18px;
                    margin-right: 4px;
                    display: inline-block;
                }
            }
        }
    }
    .dialog-footer {
        display: flex;
        justify-content: flex-end;
    }
}
</style>
